export default () => ({
  isShown: false,
  transactionsId: null,
  typeModal: 'rejected',
  errors: [],
});
